import { callAPI } from "../../network/networkConnection";
import { NetworkConfiguration } from "../../network/networkConfriguation";
import { getAuthLocalStorage } from "../../storage/localStorage";

const getAllProductDrafts = (queryParams) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS +
      queryParams,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};


const getProductDraftById = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS +
      `/${id}`,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const updateProductDraft = (id, updateData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS +
      `/${id}`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(updateData)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const updateProductDraftVariant = (id, variantPayload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS +
      `/${id}/variant`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(variantPayload)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const updateDraftVariantDimensions = (id, payload) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS +
      `/${id}/variant-dimensions`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(payload || {})
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const deleteProductDraft = (id) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS +
      `/${id}`,
      "DELETE",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// const getProductDraftStats = () => {
//   return new Promise((resolve, reject) => {
//     callAPI(
//       process.env.REACT_APP_APIUrl +
//       NetworkConfiguration.ADMIN_PRODUCT_DRAFTS_STATS,
//       "GET",
//       {
//         "Content-Type": "application/json",
//       }
//     )
//       .then((res) => {
//         resolve(res);
//       })
//       .catch((err) => {
//         reject(err);
//       });
//   });
// };

const updateProductDraftImages = (id, imageData) => {
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS +
      `/${id}/images`,
      "PUT",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(imageData)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Build query string for product draft filter
const buildProductDraftFilterQueryString = (filters = {}) => {
  const sp = new URLSearchParams();
  if (filters.search) sp.set("search", filters.search);
  if (filters.status) sp.set("status", String(filters.status));
  if (filters.errorFilter) sp.set("errorFilter", filters.errorFilter);
  const multiThirdIds = Array.isArray(filters.globalCategoryThirdIds)
    ? filters.globalCategoryThirdIds.map((v) => String(v || "").trim()).filter(Boolean)
    : [];
  if (multiThirdIds.length > 0) {
    sp.set("thirdCategoryIds", multiThirdIds.join(","));
  }
  if (filters.globalCategoryThirdId) {
    sp.set("thirdCategoryId", filters.globalCategoryThirdId);
  }
  if (filters.createdFrom) sp.set("createdFrom", filters.createdFrom);
  if (filters.createdTo) sp.set("createdTo", filters.createdTo);
  if (filters.batchId) sp.set("batchId", String(filters.batchId).trim());
  if (filters.isWhiteImageAvailable) {
    sp.set("isWhiteImageAvailable", String(filters.isWhiteImageAvailable));
  }
  if (filters.moqFrom !== "" && filters.moqFrom != null) {
    sp.set("moqFrom", String(filters.moqFrom).trim());
  }
  if (filters.moqTo !== "" && filters.moqTo != null) {
    sp.set("moqTo", String(filters.moqTo).trim());
  }
  const qs = sp.toString();
  return qs ? `?${qs}` : "";
};

/** Downloads xlsx: same columns as SKU upload template; SKU filled for all drafts matching filters. */
const downloadSkuUploadTemplateForFilteredDrafts = async (filters) => {
  const loginHeader = getAuthLocalStorage()?.loginHeader;
  if (!loginHeader) {
    throw new Error("Not logged in");
  }
  const q = buildProductDraftFilterQueryString(filters);
  const url =
    process.env.REACT_APP_APIUrl +
    NetworkConfiguration.ADMIN_PRODUCT_DRAFTS_EXPORT_SKU_UPLOAD_TEMPLATE +
    q;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${loginHeader}`,
    },
  });
  const contentType = response.headers.get("content-type") || "";
  if (!response.ok) {
    if (contentType.includes("application/json")) {
      const data = await response.json().catch(() => null);
      const msg =
        data?.error?.message ||
        data?.message ||
        `Export failed (${response.status})`;
      throw new Error(msg);
    }
    throw new Error(`Export failed (${response.status})`);
  }
  const blob = await response.blob();
  const urlObj = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = urlObj;
  link.download = "sku_upload_template.xlsx";
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(urlObj);
};

const listDraftSkuUploadBatches = ({ search = "", offset = 0, limit = 20 } = {}) => {
  const sp = new URLSearchParams();
  if (search) sp.set("search", search);
  sp.set("offset", String(offset));
  sp.set("limit", String(limit));
  const qs = sp.toString();
  const q = qs ? `?${qs}` : "";
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS_SKU_UPLOAD_BATCHES +
      q,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Get global category facets for product draft list
const getDraftGlobalCategoryFacets = ({
  errorFilter = "",
  createdFrom = "",
  createdTo = "",
  search = "",
  offset = 0,
  limit = 100,
  batchId = "",
  isWhiteImageAvailable = "",
  status = "",
  moqFrom = "",
  moqTo = "",
} = {}) => {
  const sp = new URLSearchParams();
  if (status) sp.set("status", String(status));
  if (errorFilter) sp.set("errorFilter", errorFilter);
  if (createdFrom) sp.set("createdFrom", createdFrom);
  if (createdTo) sp.set("createdTo", createdTo);
  if (search) sp.set("search", search);
  if (batchId) sp.set("batchId", String(batchId).trim());
  if (isWhiteImageAvailable) sp.set("isWhiteImageAvailable", String(isWhiteImageAvailable));
  if (moqFrom !== "" && moqFrom != null) sp.set("moqFrom", String(moqFrom).trim());
  if (moqTo !== "" && moqTo != null) sp.set("moqTo", String(moqTo).trim());
  sp.set("offset", String(offset));
  sp.set("limit", String(limit));
  const qs = sp.toString();
  const q = qs ? `?${qs}` : "";
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS_GLOBAL_CATEGORY_FACETS +
      q,
      "GET",
      {
        "Content-Type": "application/json",
      }
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Bulk update draft dimensions
const bulkUpdateDraftDimensions = (items, batchOpts = {}) => {
  const body = { items };
  if (batchOpts.batchIndex != null) body.batchIndex = batchOpts.batchIndex;
  if (batchOpts.batchTotal != null) body.batchTotal = batchOpts.batchTotal;
  return new Promise((resolve, reject) => {
    callAPI(
      process.env.REACT_APP_APIUrl +
      NetworkConfiguration.ADMIN_PRODUCT_DRAFTS_BULK_UPDATE_DIMENSIONS,
      "POST",
      {
        "Content-Type": "application/json",
      },
      JSON.stringify(body)
    )
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const productDraftApiService = {
  getAllProductDrafts,
  getProductDraftById,
  updateProductDraft,
  updateProductDraftVariant,
  updateDraftVariantDimensions,
  deleteProductDraft,
  // getProductDraftStats,
  updateProductDraftImages,
  getDraftGlobalCategoryFacets,
  listDraftSkuUploadBatches,
  downloadSkuUploadTemplateForFilteredDrafts,
  bulkUpdateDraftDimensions,
};

